export const SpinnerComponent = ({ className }: { className?: string }) => {
  return (
    <div
      className={
        className
          ? `relative animate-spin ${className} border-brand-500 rounded-full`
          : 'relative animate-spin border-4 h-11 w-11 border-brand-500 rounded-full'
      }
      style={{ borderRightColor: 'transparent' }}
    ></div>
  );
};
